import { render } from "./Routepanel.vue?vue&type=template&id=f3654f32"
import script from "./Routepanel.vue?vue&type=script&lang=js"
export * from "./Routepanel.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__